import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styles from "./index.module.css"
import logo from '../assets/logo_irrigacion.png'
const footer = () => {
  return (
    <div className={styles.footer}>
      <Container>
        <Row>
          <Col lg={4}>
            <img src={logo} className={styles.logo}></img>
          </Col>
          <Col lg={4}>
            <a href='https://www.irrigacion.gov.ar/web/'><h6>IRRIGACION</h6></a>
            <p>Departamento General de Irrigacion.</p>
            <p>Barcala 202, Ciudad, Mendoza, Argentina.</p>
           
          </Col>
          <Col lg={4} >
            <h6>Seguinos</h6>
            <div className={styles.social}>
              <li><a href='https://www.instagram.com/irrigacionmza/' target='_blank'><i class="fa-brands fa-instagram"></i></a></li>
              <li><a href='https://x.com/IrrigacionMza' target='_blank'><i class="fa-brands fa-x-twitter"></i></a></li>
              <li><a href='https://www.youtube.com/channel/UCos0ALtEv5foTVicVu6E3ug' target="_blank"><i class="fa-brands fa-youtube"></i></a></li>
              <li><a href='https://www.facebook.com/IrrigacionMza/' target='_blank'><i class="fa-brands fa-facebook"></i></a></li>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default footer